import { LeafletProvider } from 'page/map-context.js';
import React from 'react';
import { useSelector } from 'react-redux';
import { IRepoState } from 'redux-state/rootReducer.js';
import { MapSlotProvider } from './map-slot-context.js';
import { MapLayoutCore } from './map.js';

const MapLayoutMemo = React.memo(MapLayoutCore);

export const MapLayoutEntry = () => {
  const data = useSelector((state: IRepoState) => state.LAYOUT.screen.layout);

  return (
    <LeafletProvider>
      <MapSlotProvider mapConfig={data.map}>
        <MapLayoutMemo data={data} />
      </MapSlotProvider>
    </LeafletProvider>
  );
};
